export class IPVoiceService {
  constructor({
    ipExtensionID = 0,
    orderID = 0,
    extensionName = null,
    extensionNo = 500,
    handsetID = 0,
    ratePlanID = 0,
    outboundANI = null,
    voicemail = false,
    voicemailEmail = null,
    mobileTwinning = null,
    contractLengthMonths = 0,
    dealerSupplied = false,
    softPhone = false,
    upgrade = false,
    softPhoneDetails = {},
    rentalHardware = false,
  } = {}) {
    this.ipExtensionID = ipExtensionID;
    this.orderID = orderID;
    this.extensionName = extensionName;
    this.extensionNo = extensionNo;
    this.handsetID = handsetID;
    this.ratePlanID = ratePlanID;
    this.outboundANI = outboundANI;
    this.voicemailEmail = voicemailEmail;
    this.mobileTwinning = mobileTwinning;
    this.voicemail = voicemail;
    this.contractLengthMonths = contractLengthMonths;
    this.dealerSupplied = dealerSupplied;
    this.upgrade = upgrade;
    (this.softPhone = softPhone), (this.softPhoneDetails = softPhoneDetails);
    this.rentalHardware = rentalHardware;
  }
}

export function CreateNewIPVoiceService(data) {
  return Object.freeze(new IPVoiceService(data));
}
